import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Input,
  Button,
  Typography,
  Popconfirm,
  Divider,
  Modal,
  Select,
  Row,
  Col,
} from "antd";
import Highlighter from "react-highlight-words";
// import {
//   ChangeQuestionModalState,
//   ChangeQuestionTableData,
//   ChangeQuestionSearchText,
//   ChangeSelectedSubjects,
// } from "../../../actions/trainerAction";
import {
  changeQuestionModalState,
  changeSelectedSubject,
} from "../../../reducers/trainer";
import { fetchAllQuestions } from "../../../features/trainerAsync";
import { fetchSubjectTableData } from "../../../features/adminAsync";
import "./allquestion.css";
import Alert from "../../../components/common/alert";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import NewQuestionForm from "../newquestion/newquestion";
import QuestionDetails from "../questionDetails/questiondetails";
import UpdateQuestion from "../updatequestion/updatequestion";
import {
  givenDifficulties,
  givenLevels,
  givenSchools,
  givenComponents,
  givenExams,
  givenYears,
  givenMathsTopics,
  givenEnglishTopics,
  givenScienceTopics,
} from "../../common/constants";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const AllQuestions = () => {
  const dispatch = useDispatch();
  const { subjectTableData } = useSelector((state) => state.admin);
  const {
    questionTableData,
    loading,
    selectedSubjects,
    NewQuestionmodalOpened,
  } = useSelector((state) => state.trainer);
  // console.log("Question",questionTableData);

  const [questionDetailsId, setQuestionDetailsId] = useState(null);
  const [questionDetailsModalOpen, setQuestionDetailsModalOpen] =
    useState(false);
  const [questionUpdateModalOpen, setQuestionUpdateModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(5);

  const openDetailsModal = useCallback((id) => {
    setQuestionDetailsId(id);
    setQuestionDetailsModalOpen(true);
  }, []);

  const closeDetailsModal = useCallback(() => {
    setQuestionDetailsId(null);
    setQuestionDetailsModalOpen(false);
  }, []);

  const openUpdateModal = useCallback((id) => {
    setQuestionDetailsId(id);
    setQuestionUpdateModalOpen(true);
  }, []);

  const closeUpdateModal = useCallback(() => {
    setQuestionDetailsId(null);
    setQuestionUpdateModalOpen(false);
  }, []);

  const openNewModal = useCallback(() => {
    dispatch(changeQuestionModalState(true));
  }, [dispatch]);

  const closeNewModal = useCallback(() => {
    dispatch(changeQuestionModalState(false));
  }, [dispatch]);

  const handleSubjectChange = useCallback(
    (subjects) => {
      dispatch(changeSelectedSubject(subjects));
      dispatch(fetchAllQuestions(subjects));
    },
    [dispatch]
  );

  const deleteQuestion = useCallback(
    async (id) => {
      try {
        const response = await SecurePost({
          url: `${apis.DELETE_QUESTION}`,
          data: { _id: id },
        });
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchAllQuestions(selectedSubjects));
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", message);
      }
    },
    [dispatch, selectedSubjects]
  );

  const handlePageSizeChange = useCallback((current, size) => {
    setPageSize(size);
  }, []);

  // const getColumnSearchProps = useCallback(
  //   (dataIndex) => ({
  //     filterDropdown: ({
  //       setSelectedKeys,
  //       selectedKeys,
  //       confirm,
  //       clearFilters,
  //     }) => (
  //       <div className="p-2">
  //         <Input
  //           ref={searchInput}
  //           placeholder={`Search ${dataIndex}`}
  //           value={selectedKeys[0]}
  //           onChange={(e) =>
  //             setSelectedKeys(e.target.value ? [e.target.value] : [])
  //           }
  //           onPressEnter={() => handleSearch(selectedKeys, confirm)}
  //           className="mb-2 w-[188px] block"
  //         />
  //         <div className="flex gap-2">
  //           <Button
  //             type="primary"
  //             onClick={() => handleSearch(selectedKeys, confirm)}
  //             icon={<SearchOutlined />}
  //             size="small"
  //             className="w-[90px]"
  //           >
  //             Search
  //           </Button>
  //           <Button
  //             onClick={() => handleReset(clearFilters, confirm)}
  //             size="small"
  //             className="w-[90px]"
  //           >
  //             Reset
  //           </Button>
  //         </div>
  //       </div>
  //     ),
  //     filterIcon: (filtered) => (
  //       <SearchOutlined className={filtered ? "text-blue-500" : ""} />
  //     ),
  //     onFilter: (value, record) =>
  //       record[dataIndex]
  //         ?.toString()
  //         .toLowerCase()
  //         .includes(value.toLowerCase()),
  //     onFilterDropdownOpenChange: (visible) => {
  //       if (visible) {
  //         setTimeout(() => searchInput.current?.select(), 100);
  //       }
  //     },
  //     render: (text) => (
  //       <Highlighter
  //         highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
  //         searchWords={[QuestionsearchText]}
  //         autoEscape
  //         textToHighlight={text?.toString() || ""}
  //       />
  //     ),
  //   }),
  //   [QuestionsearchText]
  // );

  // const handleSearch = useCallback(
  //   (selectedKeys, confirm) => {
  //     confirm();
  //     dispatch(changeQuestionSearchText(selectedKeys[0] || ""));
  //   },
  //   [dispatch]
  // );

  // const handleReset = useCallback(
  //   (clearFilters, confirm) => {
  //     clearFilters();
  //     confirm();
  //     dispatch(changeQuestionSearchText(""));
  //   },
  //   [dispatch]
  // );

  useEffect(() => {
    dispatch(fetchSubjectTableData());
    dispatch(fetchAllQuestions(selectedSubjects));
  }, [dispatch, selectedSubjects]);

  const columns = [
    {
      title: <span style={{ color: 'black' }}>Subject</span>,
      dataIndex: ["subject", "topic"],
      key: "subject.topic",
      width: "100px",
      align: "center",
      render: (text) => <span style={{ color:'black' }}>{text}</span>,
    },
    {
      title: <span style={{ color: 'black' }}>Question</span>,
      dataIndex: "body",
      key: "body",
      width: "150px",
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          style={{color:"black"}}
        />
      ),
    },
    {
      title: <span style={{ color: 'black' }}>Explanation</span>,
      dataIndex: "explanation",
      key: "explanation",
      width: "200px",
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          style={{color:"black"}}
        />
      ),
      // reduct: (l) => {
      //   const columnData = givenLevels.find((lv) => lv.value === l);
      //   return columnData ? columnData.label : "";
      // },
      // filters: givenLevels.map((lv) => ({
      //   text: lv.label,
      //   value: lv.value,
      // })),
      // onFilter: (value, record) =>
      //   record.level?.toLowerCase().startsWith(value.toLowerCase()),
      // filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Level</span>,
      dataIndex: "level",
      key: "level",
      width: "130px",
      align: "center",
      sorter: (a, b) => {
        const levels = [
          "primary 1",
          "primary 2",
          "primary 3",
          "primary 4",
          "primary 5",
          "primary 6",
          "secondary 1",
          "secondary 2",
          "secondary 3",
          "secondary 4",
          "secondary 5",
        ];

        const indexA = levels.indexOf(a.level);
        const indexB = levels.indexOf(b.level);
        return indexA - indexB;
      },
      render: (l) => {
        const columnData = givenLevels.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenLevels.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.level?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Difficulty</span>,
      dataIndex: "difficulty",
      key: "difficulty",
      width: "130px",
      align: "center",
      sorter: (a, b) => {
        const difficulties = ["basic", "moderate", "challenging"];
        return (
          difficulties.indexOf(a.difficulty) -
          difficulties.indexOf(b.difficulty)
        );
      },
      render: (l) => {
        const columnData = givenDifficulties.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenDifficulties.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.difficulty?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Topic</span>,
      dataIndex: "topic",
      key: "topic",
      width: "130px",
      align: "center",
      sorter: (a, b) => {
        const topics = [
          ...givenMathsTopics,
          ...givenEnglishTopics,
          ...givenScienceTopics,
        ];
        const indexA = topics.findIndex((topic) => topic.value === a.topic);
        const indexB = topics.findIndex((topic) => topic.value === b.topic);
        return indexA - indexB;
      },
      render: (l) => {
        const columnData = [
          ...givenMathsTopics,
          ...givenEnglishTopics,
          ...givenScienceTopics,
        ].find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: [
        ...givenMathsTopics,
        ...givenEnglishTopics,
        ...givenScienceTopics,
      ].map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.topic?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>School</span>,
      dataIndex: "school",
      key: "school",
      width: "120px",
      align: "center",
      sorter: (a, b) => a.school?.localeCompare(b.school),
      render: (l) => {
        const columnData = givenSchools.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenSchools.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.school?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Exam</span>,
      dataIndex: "exam",
      key: "exam",
      width: "120px",
      align: "center",
      sorter: (a, b) => a.exam?.localeCompare(b.exam),
      render: (l) => {
        const columnData = givenExams.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenExams.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.exam?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Component</span>,
      dataIndex: "component",
      key: "component",
      width: "150px",
      align: "center",
      sorter: (a, b) => a.component?.localeCompare(b.component),
      render: (l) => {
        const columnData = givenComponents.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenComponents.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.component?.toLowerCase() === value.toLowerCase(),
      filterSearch: true,
    },
    {
      title: <span style={{ color: 'black' }}>Year</span>,
      dataIndex: "year",
      key: "year",
      width: "100px",
      align: "center",
      sorter: (a, b) => a.year?.localeCompare(b.year),
      render: (l) => {
        const columnData = givenYears.find((df) => df.value === l);
        return columnData ? <span style={{ color:'black' }}>{columnData?.label}</span> : "";
      },
      filters: givenYears.map((df) => ({
        text: df.label,
        value: df.value,
      })),
      onFilter: (value, record) =>
        record.year?.toLowerCase().startsWith(value.toLowerCase()),
      filterSearch: true,
    },

    {
      title: <span style={{ color: 'black' }}>Image</span>,
      dataIndex: "quesimg",
      key: "quesimg",
      width: "150px",
      align: "center",
      render: (quesimg) => {
        const image = quesimg && quesimg.split("www.leagueonline.sg:5000");
        const path = apis.BASE_LOCAL_URL;
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
        const videoExtensions = ["mp4", "avi", "mov", "mkv"];
        // Extract the file extension from the URL
        const extension =
          quesimg == undefined || quesimg == null
            ? ""
            : image && image[0] === "https://"
            ? image[1].split(".").pop().toLowerCase()
            : quesimg.split(".").pop().toLowerCase();
        return (
          <div>
            {quesimg == undefined ||
            quesimg == null ? null : imageExtensions.includes(extension) ? (
              image && image[0] === "https://" ? (
                <a href={path + image[1]} target="_blank">
                  <img src={path + image[1]} width={"100px"} />
                </a>
              ) : (
                <a href={path + "/" + quesimg} target="_blank">
                  <img src={path + "/" + quesimg} width={"100px"} />{" "}
                </a>
              )
            ) : videoExtensions.includes(extension) ? (
              image && image[0] === "https://" ? (
                <a href={path + image[1]} target="_blank">
                  <video width="100" controls>
                    <source src={path + image[1]} type="video/mp4" />
                  </video>
                </a>
              ) : (
                <a href={path + "/" + quesimg} target="_blank">
                  <video width="100" controls>
                    <source src={path + "/" + quesimg} type="video/mp4" />
                  </video>
                </a>
              )
            ) : null}
          </div>
        );
      },
    },
    {
      title: <span style={{ color: 'black' }}>Action</span>,
      key: "_id",
      dataIndex: "_id",
      width: "80px",
      render: (key) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            shape="circle"
            onClick={() => openDetailsModal(key)}
            icon={<InfoCircleOutlined />}
          />
          <Button
            type="primary"
            shape="circle"
            onClick={() => openUpdateModal(key)}
            icon={<EditOutlined />}
          />
          <Popconfirm
            title="Are you sure?"
            cancelText="No"
            okText="Yes"
            onConfirm={() => deleteQuestion(key)}
            icon={<DeleteOutlined className="text-red-500" />}
          >
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </div>
      ),
    },
  ];
  return (
    <div className="admin-table-container">
      <div>
        <Row style={{ marginBottom: "10px" }}>
          <Col span={12}>
            <Button
              type="primary"
              icon={<QuestionCircleOutlined />}
              onClick={() => openNewModal()}
              className="bg-blue-500 hover:bg-blue-600"
            >
              Add New Question
            </Button>
          </Col>
          <Col span={12}>
            <Select
              mode="multiple"
              placeholder="Select one or more subjects"
              value={selectedSubjects}
              onChange={handleSubjectChange}
              className="w-full"
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: "100%" }}
            >
              {subjectTableData.map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.topic}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
      <div className="register-trainer-form-header">
        <Typography.Title
          level={4}
          style={{
            color: "#fff",
            textAlign: "center",
            margin: -10,
            padding: "10px 0",
          }}
        >
          List of Questions
        </Typography.Title>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={questionTableData}
        pagination={{
          pageSize,
          pageSizeOptions: ["5", "10", "20", "30", "50"],
          showSizeChanger: true,
          onShowSizeChange: handlePageSizeChange,
        }}
        loading={loading}
        rowKey="_id"
        scroll={{ x: "max-content" }} // enables horizontal scrolling
      />

      <Modal
        open={NewQuestionmodalOpened}
        title="New Question"
        onCancel={closeNewModal}
        className="top-5"
        width="80%"
        destroyOnHidden={true}
        footer={null}
        style={{ maxHeight: "75vh", overflow: "auto" }}
      >
        <NewQuestionForm />
      </Modal>
      <Modal
        open={questionDetailsModalOpen}
        title="Question Details"
        onCancel={closeDetailsModal}
        className="top-5"
        width="70%"
        destroyOnHidden
        footer={null}
      >
        <QuestionDetails id={questionDetailsId} />
      </Modal>
      <Modal
        open={questionUpdateModalOpen}
        title="Update Question"
        onCancel={closeUpdateModal}
        className="top-5"
        width="90%"
        destroyOnHidden={true}
        footer={null}
      >
        <UpdateQuestion
          id={questionDetailsId}
          closeUpdateModal={closeUpdateModal}
        />
      </Modal>
    </div>
  );
};

export default AllQuestions;
